export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              关于麻花影院
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              致力于打造全网最优质的免费在线观影平台
            </p>
          </div>

          <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-2/5">
                <div className="h-48 lg:h-full min-h-[200px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20soft%20amber%20ambient%20lighting%2C%20comfortable%20viewing%20atmosphere%2C%20modern%20minimal%20interior%2C%20dark%20walls%20with%20warm%20accents%2C%20no%20people%20visible%2C%20cinematic%20aesthetic&width=800&height=600&seq=mahua-about-01&orientation=landscape"
                    alt="麻花影院品牌形象"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="lg:w-3/5 p-6 md:p-8 lg:p-10 flex flex-col justify-center">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-4">
                  你的随身免费影院
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  麻花影院创建于2020年，是国内领先的免费在线影视观看平台。我们致力于聚合全网优质影视资源，为用户提供无需付费、高清流畅的观影体验。平台涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日实时更新片源。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  麻花影院免费观看的理念很简单：让每个人都能轻松享受优质影视内容的乐趣。我们相信，好的内容不应该被付费门槛阻隔。无论你身处何地、使用何种设备，打开麻花影院就能畅享不间断的视听盛宴。
                </p>
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center p-3 rounded-lg bg-background-50">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">5年+</div>
                    <div className="text-xs text-foreground-500">稳定运营</div>
                  </div>
                  <div className="text-center p-3 rounded-lg bg-background-50">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500 mb-1">10万+</div>
                    <div className="text-xs text-foreground-500">影视资源</div>
                  </div>
                  <div className="text-center p-3 rounded-lg bg-background-50">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">千万+</div>
                    <div className="text-xs text-foreground-500">月活用户</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}